import { Params } from '@angular/router';

/**
 * True when the current shell must still use the legacy MSAL flow instead of
 * Better Auth / OIDC. All platforms (web, Electron, iOS, Android) follow the
 * shared `useBetterAuth` flag — native `loginIOS`/`loginAndroid` dispatch to
 * `loginWebDispatch` when the flag is on.
 */
export function usesNativeMsalFlow(useBetterAuth: boolean): boolean {
  return !useBetterAuth;
}

/** True when the issuer redirected here mid-authorize (full OAuth query preserved). */
export function hasPendingOidcAuthorizeRequest(q: Params): boolean {
  return (
    q['response_type'] === 'code' &&
    typeof q['client_id'] === 'string' &&
    q['client_id'].length > 0 &&
    typeof q['redirect_uri'] === 'string' &&
    q['redirect_uri'].length > 0
  );
}

export function buildOidcAuthorizeResumeUrl(
  issuerBaseUrl: string,
  queryParams: Params,
  loginHint: string,
): string {
  const base = issuerBaseUrl.replace(/\/+$/, '');
  const sp = new URLSearchParams();
  for (const key of Object.keys(queryParams)) {
    if (key === 'login_hint') continue;
    const v = queryParams[key];
    if (v === undefined || v === null) continue;
    if (Array.isArray(v)) {
      for (const item of v) {
        sp.append(key, item);
      }
    } else {
      sp.set(key, v);
    }
  }
  sp.set('login_hint', loginHint);
  return `${base}/api/auth/oauth2/authorize?${sp.toString()}`;
}
